import styled from 'styled-components'

export const DialogContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const Label = styled.label`
    font-weight: bold;
`

export const ErrorMessage = styled.div`
    color: red;
    font-size: 0.9rem;
`

export const ButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 1rem;
`

export const ReadonlyField = styled.div`
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: #555;
    display: flex;
    justify-content: space-between;
`
